import { useState } from "react";
import { useParams } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore"; 
import Lang from './Lang';


export default function UninstallSurveyGeneral(props){
 const {language} = useParams();
    let lang = language;
    document.title = "Image downloader";
    const locals = ['pt','es','fr','de','it','hu','tr','ru','he','vi','th','ko','zh_CN','zh_TW','ja'];                
    if(!locals.includes(lang)){
      lang='en';
    }


const translation = {
  "en": [
    "You uninstalled the extension",
    "We want to do better - Tell us what went wrong.",
    "I uninstall the extension because...",
    "Submit",
    "Thank you for your feedback"
  ],
  "de": [
    "Sie haben die Erweiterung deinstalliert",
    "Wir möchten uns verbessern – sagen Sie uns, was schiefgelaufen ist.",
    "Ich deinstalliere die Erweiterung, weil...",
    "Absenden",
    "Vielen Dank für Ihr Feedback"
  ],
  "es": [
    "Desinstalaste la extensión",
    "Queremos mejorar. Cuéntanos qué salió mal.",
    "Desinstalé la extensión porque...",
    "Enviar",
    "Gracias por tus comentarios"
  ],
  "he": [
    "הסרת את ההרחבה",
    "אנחנו רוצים להשתפר – ספר לנו מה השתבש.",
    "הסרתי את ההרחבה כי...",
    "שלח",
    "תודה על המשוב שלך"
  ],
  "hu": [
    "Eltávolította a bővítményt",
    "Jobbak szeretnénk lenni – mondja el, mi volt a probléma.",
    "Azért távolítottam el a bővítményt, mert...",
    "Küldés",
    "Köszönjük a visszajelzést"
  ],
  "fr": [
    "Vous avez désinstallé l’extension",
    "Nous voulons nous améliorer – dites-nous ce qui n’a pas fonctionné.",
    "J’ai désinstallé l’extension parce que...",
    "Envoyer",
    "Merci pour votre retour"
  ],
  "it": [
    "Hai disinstallato l'estensione",
    "Vogliamo migliorare – dicci cosa non ha funzionato.",
    "Ho disinstallato l'estensione perché...",
    "Invia",
    "Grazie per il tuo feedback"
  ],
  "ja": [
    "拡張機能をアンインストールしました",
    "もっと良くしたいので、問題を教えてください。",
    "アンインストールした理由は...",
    "送信",
    "ご意見ありがとうございます"
  ],
  "ko": [
    "확장 프로그램을 제거하셨습니다",
    "더 나아지고 싶어요 – 무엇이 문제였는지 알려주세요.",
    "확장 프로그램을 제거한 이유는...",
    "제출",
    "피드백 감사합니다"
  ],
  "ru": [
    "Вы удалили расширение",
    "Мы хотим стать лучше — расскажите, что пошло не так.",
    "Я удалил(а) расширение, потому что...",
    "Отправить",
    "Спасибо за ваш отзыв"
  ],
  "pt": [
    "Você desinstalou a extensão",
    "Queremos melhorar – diga-nos o que deu errado.",
    "Desinstalei a extensão porque...",
    "Enviar",
    "Obrigado pelo seu feedback"
  ],
  "th": [
    "คุณได้ถอนการติดตั้งส่วนขยายแล้ว",
    "เราต้องการปรับปรุง – บอกเราว่ามีอะไรผิดพลาด",
    "ฉันถอนการติดตั้งส่วนขยายเพราะ...",
    "ส่ง",
    "ขอบคุณสำหรับความคิดเห็นของคุณ"
  ],
  "tr": [
    "Eklentiyi kaldırdınız",
    "Daha iyi olmak istiyoruz – neyin yanlış gittiğini bize söyleyin.",
    "Eklentiyi kaldırmamın nedeni...",
    "Gönder",
    "Geri bildiriminiz için teşekkürler"
  ],
  "vi": [
    "Bạn đã gỡ cài đặt tiện ích",
    "Chúng tôi muốn cải thiện – hãy cho chúng tôi biết điều gì đã xảy ra.",
    "Tôi gỡ cài đặt tiện ích vì...",
    "Gửi",
    "Cảm ơn bạn đã phản hồi"
  ],
  "zh_CN": [
    "你已卸载扩展程序",
    "我们希望做得更好——请告诉我们哪里出了问题。",
    "我卸载扩展程序是因为...",
    "提交",
    "感谢您的反馈"
  ],
  "zh_TW": [
    "您已解除安裝擴充功能",
    "我們希望變得更好——請告訴我們發生了什麼問題。",
    "我解除安裝擴充功能是因為...",
    "提交",
    "感謝您的回饋"
  ]
};
const {version} = useParams();
const suffix="/"+version;
const { subject } = useParams();
document.title = subject+" - unistall survey";
document.body.style = "background-image: url('/assets/forest.jpg'); background-repeat: no-repeat;  background-attachment: fixed; background-size: 100% 100%;";
const [submited, setSubmited] = useState(false);
const [body, setBody] = useState("");

const submit = async (event) =>{
    event.preventDefault();
    if(body!=""){
        const docRef = await setDoc(doc(props.db, "emails",Date.now().toString()), {
            message: {
                subject: subject + " - unistall survey "+version+lang,
                html: body,
            }
        });
    }
    setSubmited(true);
}
function bugHunt(){
  return(
    <>
If the reason you uninstalled the extension is because it didn’t work at all, 
you may be able to earn an <strong color="red">$8 Amazon gift card</strong> by{" "}
<a href="/bug-hunt.html" target="_blank">
  participating
</a> in our bug hunt program.<br /><br />    </>
    )
}
if(submited){ return(<div className="u-s-page-header" style={{padding: "24px", margin: "48px", backgroundColor: "rgba(255, 255, 255, 0.9)"}}>{translation[lang][4]} :-{")"}</div>)}else{
    return(
                <div style={{direction: lang != 'he' ? 'ltr' : 'rtl'}}>
<div style={{backgroundColor: "rgba(111, 111, 111, 0.9)", marginTop:"64px", padding: "32px 16px 16px 16px", borderRadius: "16px"}}>
    <Lang suffix = {suffix} />
    <div className="u-s-page-header" style={{textAlign:"start", marginLeft: "16px"}}>{translation[lang][0]}</div>
    <div className="u-s-main-title" style={{marginLeft: "16px", fontFamily: "Helvetica" , fontSize: "2em"}}>
        <p>{translation[lang][1]}</p>
    </div>
    <span style={{color:"white"}}> 
        &nbsp;
    </span>
    <div className="u-s-container" style={{backgroundColor: "transparent", padding: "1em"}}>
        <form id="form" onSubmit={submit}>
            <textarea id="content" name="content" placeholder={translation[lang][2]}
                style={{height:"150px", width: "100%", padding: "12px", border: "1px solid #ccc", borderRadius: "4px", boxSizing: "border-box", marginTtop: "6px", marginBottom: "16px", resize: "vertical"}} onChange={(e) => setBody(e.target.value)}></textarea>
    {language=="en"&&subject=="image_downloader" ? bugHunt() : ""} 
            <input style={{ color: "white", padding: "12px 20px", border: "none", borderRadius: "4px", cursor: "pointer"}} type="submit" value={translation[lang][3]} />
    
      </form>
    </div>
    
</div>   
</div>
    )
}
}
